
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Check, AlertTriangle, X } from "lucide-react";

interface FormStatusMessageProps {
  status: 'idle' | 'success' | 'partial-success' | 'error';
}

const FormStatusMessage = ({ status }: FormStatusMessageProps) => {
  if (status === 'idle') return null;
  
  switch (status) {
    case 'success':
      return (
        <Alert className="mt-4 bg-green-50 border-green-200">
          <Check className="h-4 w-4 text-green-600" />
          <AlertTitle className="text-green-800">Sõnum saadetud</AlertTitle>
          <AlertDescription className="text-green-700">
            Täname ühendust võtmast. Vastame esimesel võimalusel.
          </AlertDescription>
        </Alert>
      );
    case 'partial-success':
      return (
        <Alert className="mt-4 bg-amber-50 border-amber-200">
          <AlertTriangle className="h-4 w-4 text-amber-600" />
          <AlertTitle className="text-amber-800">Sõnum osaliselt saadetud</AlertTitle>
          <AlertDescription className="text-amber-700">
            Sinu kontakt on salvestatud, kuid mõne funktsiooni töötlemisel esines tõrge. Võtame sinuga ühendust esimesel võimalusel.
          </AlertDescription>
        </Alert>
      );
    case 'error':
      return (
        <Alert className="mt-4 bg-red-50 border-red-200">
          <X className="h-4 w-4 text-red-600" />
          <AlertTitle className="text-red-800">Viga</AlertTitle>
          <AlertDescription className="text-red-700">
            Tekkis viga sõnumi saatmisel. Palun proovige hiljem uuesti.
          </AlertDescription>
        </Alert>
      );
    default:
      return null;
  }
};

export default FormStatusMessage;
